'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultSnowplowConfigs = exports.packageVersion = exports.FanSnowplowTracker = exports.PerformanceCoreTracker = exports.InstatTracker = exports.PlaylistsSnowplowTracker = exports.VideoIntegrationSnowplowTracker = exports.ContentSearchSnowplowTracker = exports.InsightsModuleSnowplowTracker = exports.WyscoutToHudlSnowplowTracker = exports.MediaUserSnowplowTracker = exports.GSLClipContext = exports.GSLVideoContext = exports.GSLFixtureContext = exports.GSLCompetitionPeriodContext = exports.GSLPlayerContext = exports.GSLTeamContext = exports.GSLCompetitionContext = exports.WyscoutVideoContext = exports.WyscoutUserContext = exports.EventPlayerContext = exports.EventTeamContext = exports.EventCompetitionContext = exports.PageEntityContext = exports.PlaylistClipContext = exports.PlaylistContext = exports.VideoContext = exports.TeamContext = exports.UserTeamContext = exports.UserOrgContext = exports.UserContext = exports.BaseContext = exports.ApplicationEntityContext = exports.SessionView = exports.SessionHeartbeat = exports.SessionActivitySnowplowTracker = exports.VideoActivitySnowplowTracker = exports.loadSnowplowScript = undefined;

var _Snowplow = require('./Snowplow');

// Populated on build/publish
var packageVersion = typeof PACKAGE_VERSION !== 'undefined' ? PACKAGE_VERSION : '' + '3.13.0'; /**
                                                                                                * Module that exports the specific user activity tracking libraries.
                                                                                                *
                                                                                                * @module UserTracking
                                                                                                */

exports.loadSnowplowScript = _Snowplow.loadSnowplowScript;
exports.VideoActivitySnowplowTracker = _Snowplow.VideoActivitySnowplowTracker;
exports.SessionActivitySnowplowTracker = _Snowplow.SessionActivitySnowplowTracker;
exports.SessionHeartbeat = _Snowplow.SessionHeartbeat;
exports.SessionView = _Snowplow.SessionView;
exports.ApplicationEntityContext = _Snowplow.ApplicationEntityContext;
exports.BaseContext = _Snowplow.BaseContext;
exports.UserContext = _Snowplow.UserContext;
exports.UserOrgContext = _Snowplow.UserOrgContext;
exports.UserTeamContext = _Snowplow.UserTeamContext;
exports.TeamContext = _Snowplow.TeamContext;
exports.VideoContext = _Snowplow.VideoContext;
exports.PlaylistContext = _Snowplow.PlaylistContext;
exports.PlaylistClipContext = _Snowplow.PlaylistClipContext;
exports.PageEntityContext = _Snowplow.PageEntityContext;
exports.EventCompetitionContext = _Snowplow.EventCompetitionContext;
exports.EventTeamContext = _Snowplow.EventTeamContext;
exports.EventPlayerContext = _Snowplow.EventPlayerContext;
exports.WyscoutUserContext = _Snowplow.WyscoutUserContext;
exports.WyscoutVideoContext = _Snowplow.WyscoutVideoContext;
exports.GSLCompetitionContext = _Snowplow.GSLCompetitionContext;
exports.GSLTeamContext = _Snowplow.GSLTeamContext;
exports.GSLPlayerContext = _Snowplow.GSLPlayerContext;
exports.GSLCompetitionPeriodContext = _Snowplow.GSLCompetitionPeriodContext;
exports.GSLFixtureContext = _Snowplow.GSLFixtureContext;
exports.GSLVideoContext = _Snowplow.GSLVideoContext;
exports.GSLClipContext = _Snowplow.GSLClipContext;
exports.MediaUserSnowplowTracker = _Snowplow.MediaUserSnowplowTracker;
exports.WyscoutToHudlSnowplowTracker = _Snowplow.WyscoutToHudlSnowplowTracker;
exports.InsightsModuleSnowplowTracker = _Snowplow.InsightsModuleSnowplowTracker;
exports.ContentSearchSnowplowTracker = _Snowplow.ContentSearchSnowplowTracker;
exports.VideoIntegrationSnowplowTracker = _Snowplow.VideoIntegrationSnowplowTracker;
exports.PlaylistsSnowplowTracker = _Snowplow.PlaylistsSnowplowTracker;
exports.InstatTracker = _Snowplow.InstatTracker;
exports.PerformanceCoreTracker = _Snowplow.PerformanceCoreTracker;
exports.FanSnowplowTracker = _Snowplow.FanSnowplowTracker;
exports.packageVersion = packageVersion;
exports.defaultSnowplowConfigs = _Snowplow.defaultSnowplowConfigs;